import http from './httpService';
import i18n from '../i18n';

const apiEndPoint = '/users';

// function url(id) {
//   return `${apiEndPoint}/${id}`;
// }

function available(email) {
  return http.get(`${apiEndPoint}/email/${email}`);
}

function register(user) {
  return http.post(apiEndPoint, {
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    password: user.password,
    teamId: user.teamId,
    isAdmin: user.isAdmin,
    language: i18n.language,
  });
}

function getUser(id, config) {
  return http.get(`${apiEndPoint}/${id}`, config);
}

// Quiet, as it's saved in the background; the caller retries it later
function saveLanguage(language) {
  return http.patch(`${apiEndPoint}/me/language`, { language }, { silent: true });
}

function resetPassword(email) {
  return http.post(`${apiEndPoint}/resetpassword`, {
    email: email,
  });
}

function changePassword(userId, token, newPassword) {
  return http.post(`${apiEndPoint}/resetpassword/new/${userId}/${token}`, {
    password: newPassword,
  });
}

function saveFavoriteSong(songId) {
  return http.patch(`${apiEndPoint}/me/favorites/${songId}`, {});
}

function removeFavoriteSong(songId) {
  return http.delete(`${apiEndPoint}/me/favorites/${songId}`);
}

function getFavoriteSongs() {
  return http.get(`${apiEndPoint}/me/favorites`);
}

function deleteUser(userId) {
  return http.delete(`${apiEndPoint}/${userId}`);
}

function checkUserHasNoTeam(userId) {
  return http.get(`${apiEndPoint}/noteam/${userId}`);
}

function updateUserTeam(userId, teamId, isAdmin = false) {
  return http.patch(`${apiEndPoint}/${userId}/team`, {
    teamId,
    isAdmin,
  });
  // isAdmin is not supported for this route as of now
}

function updateUserPermissions(userId, permissions) {
  return http.patch(`${apiEndPoint}/${userId}/permissions`, permissions);
}

const userService = {
  available,
  register,
  getUser,
  saveLanguage,
  saveFavoriteSong,
  removeFavoriteSong,
  getFavoriteSongs,
  resetPassword,
  changePassword,
  deleteUser,
  checkUserHasNoTeam,
  updateUserTeam,
  updateUserPermissions,
};
export default userService;
